import React from 'react';

export default function Loader() {
  return (
    <div className="flex-center" style={{ height: '100%' }}>
      <div className="loader-spinner"></div>
    </div>
  );
}
